import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';

var INTERPOLATE_PREFIX = '%(';
var INTERPOLATE_SUFFIX = ')s';
var INTERPOLATE_REGEXP = /%\(\w+\)s/g;
var Interpolate = function (props) {
    var substrings = useMemo(function () { return props.str.split(INTERPOLATE_REGEXP); }, [props.str]);
    var components = useMemo(function () { return props.str.match(INTERPOLATE_REGEXP); }, [props.str]);
    var Tag = (props.parentTag || 'div');
    return (jsx(Tag, { className: props.className || '', children: substrings.map(function (substring, i) {
            var _a;
            var component = (_a = components === null || components === void 0 ? void 0 : components[i]) === null || _a === void 0 ? void 0 : _a.replace(INTERPOLATE_PREFIX, '').replace(INTERPOLATE_SUFFIX, '');
            return (jsxs(React__default.Fragment, { children: [jsx("span", { dangerouslySetInnerHTML: { __html: substring } }), component && props[component] !== null && typeof props[component] !== undefined
                        ? props.noWrap
                            ? props[component]
                            : (jsx("div", { style: { display: 'inline-block' }, children: props[component] }))
                        : null] }, "substring_".concat(i, "_").concat(component)));
        }) }));
};
var Interpolate$1 = React__default.memo(Interpolate);

export { Interpolate$1 as default };
//# sourceMappingURL=Interpolate.js.map
